import Avatar from "@material-ui/core/Avatar/Avatar";
import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined";
import NotInterestedOutlined from "@material-ui/icons/NotInterestedOutlined";

import React from "react";

const tabConfig = [
  {
    columnTitle: "",
    dataField: ["component"],
    component: ({ values }) => {
      return values.isSubscribed ? (
        <CheckCircleOutlined color="primary" />
      ) : (
        <NotInterestedOutlined color="disabled" />
      );
    },
  },
  {
    columnTitle: "",
    dataField: ["component"],
    component: ({ values }) => {
      return values.isActive ? (
        <CheckCircleOutlined color="primary" />
      ) : (
        <NotInterestedOutlined color="disabled" />
      );
    },
  },
  {
    columnTitle: "",
    dataField: ["component"],
    component: ({ values }) => {
      return <Avatar src={values.photoURL} variant="rounded" />;
    },
  },
  {
    columnTitle: "Name",
    dataField: ["fullName"],
  },

  {
    columnTitle: "Email",
    dataField: ["email"],
  },

  {
    columnTitle: "Experience",
    dataField: ["experience"],
  },
];

export default tabConfig;
